module.exports = __webpack_public_path__ + "img/201712-1.a5f56b84.jpeg";